import { useSearchParams } from 'react-router-dom';
import { useDocumentTitle } from '@/hooks';
import { EventsPage } from './events/EventsPage';
import {
    usePersonEventsScenario,
    useRecentEventsScenario,
    useRelatedEventsScenario,
    useVehicleEventsScenario,
} from './events/scenarios';

function RecentEventsScenarioPage() {
    const scenario = useRecentEventsScenario();
    return <EventsPage scenario={scenario} />;
}

function RelatedEventsScenarioPage() {
    const scenario = useRelatedEventsScenario();
    return <EventsPage scenario={scenario} />;
}

function VehicleEventsScenarioPage() {
    const scenario = useVehicleEventsScenario();
    return <EventsPage scenario={scenario} />;
}

function PersonEventsScenarioPage() {
    const scenario = usePersonEventsScenario();
    return <EventsPage scenario={scenario} />;
}

export default function Events() {
    useDocumentTitle('events');
    const [searchParams] = useSearchParams();
    const eventId = searchParams.get('eventId');
    const vehicleId = searchParams.get('vehicleId');
    const personId = searchParams.get('personId');

    if (eventId) {
        return <RelatedEventsScenarioPage />;
    }

    if (vehicleId) {
        return <VehicleEventsScenarioPage />;
    }

    if (personId) {
        return <PersonEventsScenarioPage />;
    }

    return <RecentEventsScenarioPage />;
}
